import { useState } from "react";
import Head from "next/head";
import Layout from "../../components/layout";
import HeroSection from "../../../seminar/components/HeroSection";
import OfferSection from "../../../seminar/components/OfferSection";
import ScheduleSection from "../../../seminar/components/ScheduleSection";
import SpeakerSection from "../../../seminar/components/SpeakerSection";
import GallerySection from "../../../seminar/components/GallerySection";
import WhyAttendSection from "../../../seminar/components/WhyAttendSection";
import FAQSection from "../../../seminar/components/FAQSection";
import SeminarRegistrationModal from "../../../seminar/components/SeminarRegistrationModal";
import SeminarFooterRegisterBar from "../../components/SeminarFooterRegisterBar.jsx";

export default function SeminarPage() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Layout>
      <Head>
        <title>
          NEET Seminar 2026 | Expert Talks, Workshops & Guidance | Neet Support
        </title>

        <meta
          name="description"
          content="Join the NEET Seminar 2026 by Neet Support. Get expert talks, workshops, guidance sessions, and tips for NEET UG aspirants. Boost your preparation with top speakers, live Q&A, and exclusive resources. Register now for India's top NEET event!"
        />

        <meta
          name="keywords"
          content="NEET seminar, NEET 2026, NEET UG, medical entrance, NEET workshop, NEET guidance, NEET preparation, NEET support, NEET registration, NEET event, NEET speakers, NEET Q&A, NEET tips, NEET aspirants, medical coaching, NEET webinar, NEET seminar registration 2026, medical entrance exam tips, NEET motivational speakers, NEET live Q&A, NEET exam preparation event, NEET aspirant support, NEET 2026 event India, NEET online seminar, NEET study strategies, NEET success stories, NEET expert panel, NEET exam counseling"
        />

        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://neetsupport.com/seminar" />
        <meta httpEquiv="Content-Language" content="en" />
        <meta name="author" content="Neet Support Team" />

        <meta
          property="og:title"
          content="NEET Seminar 2026 | Expert Talks, Workshops & Guidance | Neet Support"
        />
        <meta
          property="og:description"
          content="Join the NEET Seminar 2026 by Neet Support. Get expert talks, workshops, guidance sessions, and tips for NEET UG aspirants. Boost your preparation with top speakers, live Q&A, and exclusive resources. Register now for India's top NEET event!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://neetsupport.com/seminar" />
        <meta
          property="og:image"
          content="https://neetsupport.com/assets/neet-seminar-banner.jpg"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="NEET Seminar 2026 | Expert Talks, Workshops & Guidance | Neet Support"
        />
        <meta
          name="twitter:description"
          content="Join the NEET Seminar 2026 by Neet Support. Get expert talks, workshops, guidance sessions, and tips for NEET UG aspirants. Boost your preparation with top speakers, live Q&A, and exclusive resources. Register now for India's top NEET event!"
        />
        <meta
          name="twitter:image"
          content="https://neetsupport.com/assets/neet-seminar-banner.jpg"
        />
      </Head>

      <main className="min-h-screen w-full overflow-x-hidden p-2 pb-24 sm:p-4 sm:pb-28">
        <HeroSection onRegister={() => setModalOpen(true)} />
        <OfferSection onRegister={() => setModalOpen(true)} />
        <WhyAttendSection />
        <ScheduleSection />
        <SpeakerSection onRegister={() => setModalOpen(true)} />
        <GallerySection />
        <FAQSection />
      </main>

      <SeminarFooterRegisterBar onRegister={() => setModalOpen(true)} />

      <SeminarRegistrationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </Layout>
  );
}